/**
 * Defines the constants used by the Auth module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */


export const VUEX_AUTH_CRITICAL_INIT_COMPLETE       = 'VUEX_AUTH_CRITICAL_INIT_COMPLETE'
export const VUEX_AUTH_ERROR                        = 'VUEX_AUTH_ERROR'
export const VUEX_AUTH_HYDRATE_FROM_TOKEN           = 'VUEX_AUTH_HYDRATE_FROM_TOKEN'
export const VUEX_AUTH_REFRESH_FROM_TOKEN           = 'VUEX_AUTH_REFRESH_FROM_TOKEN'
export const VUEX_AUTH_LOGOUT                       = 'VUEX_AUTH_LOGOUT'
export const VUEX_AUTH_REQUEST                      = 'VUEX_AUTH_REQUEST'
export const VUEX_AUTH_REQUEST_STATE_ERROR          = 'error'
export const VUEX_AUTH_REQUEST_STATE_LOADING        = 'loading'
export const VUEX_AUTH_REQUEST_STATE_SUCCESS        = 'success'
export const VUEX_AUTH_REQUIREMENTS_LOADED          = 'VUEX_AUTH_REQUIREMENTS_LOADED'
export const VUEX_AUTH_SUCCESS                      = 'VUEX_AUTH_SUCCESS'
export const VUEX_AUTH_REFRESH_CURRENT_USER_AVATAR  = 'VUEX_AUTH_REFRESH_CURRENT_USER_AVATAR'

//SWITCH USER
export const VUEX_AUTH_SWITCH_USER                  = 'VUEX_AUTH_SWITCH_USER'